import { ActionCreator } from 'store/redux/ActionCreators';
import { TrialRegion } from 'types/TrialRegion';
import { ErrorTypes } from '../../../constants/errorTypes';

export enum TrialRegionActionType {
  FetchTrialRegionsRejected = 'FETCH_TRIAL_REGIONS_REJECTED',
  FetchTrialRegionsResolved = 'FETCH_TRIAL_REGIONS_RESOLVED',
  FetchTrialRegions = 'FETCH_TRIAL_REGIONS',
}

export interface FetchTrialRegions {
  type: TrialRegionActionType.FetchTrialRegions;
}

interface FetchTrialRegionsResolved {
  type: TrialRegionActionType.FetchTrialRegionsResolved;
  payload: TrialRegion;
}

interface FetchTrialRegionsRejected {
  type: TrialRegionActionType.FetchTrialRegionsRejected;
  payload: {
    error: ErrorTypes;
  };
}

export type TrialRegionActions =
  | FetchTrialRegions
  | FetchTrialRegionsRejected
  | FetchTrialRegionsResolved;

export interface TrialRegionActionsCreators {
  fetchTrialRegions: ActionCreator<
    { fieldId: string; programId: string },
    FetchTrialRegions
  >;
  fetchTrialRegionsResolved: ActionCreator<
    TrialRegion,
    FetchTrialRegionsResolved
  >;
  fetchTrialRegionsRejected: ActionCreator<
    ErrorTypes,
    FetchTrialRegionsRejected
  >;
}
